import { render, staticRenderFns } from "./MarketplaceContractAccept.vue?vue&type=template&id=2bbf5bed&scoped=true&"
import script from "./MarketplaceContractAccept.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf5bed",
  null
  
)

export default component.exports